<template>
    <div>
        <el-card shadow="hover">
            <el-form inline :model="query" size="small">
                <div @keydown.enter="doLoad()">
                    <div style="float: left;">
                        <el-form-item>
                            <el-select v-model="query.pid" placeholder="请选择招聘计划" style="width:250px;" @change="doLoad">
                                <el-option v-for="plan in plans" :key="plan.id" :label="plan.name" :value="plan.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </el-card>
        <el-alert type="success" style="margin-top: 5px;" :closable="false">
            <p solt="title">
                合计招聘人数：{{ data.count }}人， 合计报名人数：{{ data.regs }}， 合计通过人数：{{ data.pass }}， 合计缴费人数：{{ data.paid }}， 准考证打印人数：{{ data.zkz }}， 面试单打印人数：{{ data.msd }}
            </p>
        </el-alert>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" style="width: 100%">
                <el-table-column show-overflow-tooltip label="岗位信息" width="250">
                    <template slot-scope="scope">
                        <p>
                            <span>[{{ scope.row.code }}] {{ scope.row.name }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招聘单位">
                    <template slot-scope="scope">
                        <p>
                            {{ scope.row.unit.name }}
                            <span v-if="scope.row.unit.dept">[{{ scope.row.unit.dept }}]</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招聘人数" width="150">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.count }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="报名人数" width="150">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.regs }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="通过人数" width="150">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.pass }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="缴费人数" width="150">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.paid }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="准考证打印" width="150">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.zkz }}</span>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="面试单打印" width="150">
                    <template slot-scope="scope">
                        <p>
                            <span>{{ scope.row.msd }}</span>
                        </p>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
const defaultQuery = {
    pid: ''
}

export default {
    name: 'RecStat',
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                count: 0,
                regs: 0,
                pass: 0,
                paid: 0
            },
            tableLoading: false,
            datas: [],
            plans: []
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['招聘管理', '报名统计'])
        this.init()
    },

    methods: {
        init() {
            this.doLoadPlan()
        },
        doLoadPlan() {
            this.$http
                .get('/comm/data/plan/query', {
                    params: {
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    this.plans = result.datas
                })
        },
        doLoad() {
            if (!this.query.pid) {
                this.$message.warning('请选择招聘计划')
                return
            }
            this.tableLoading = true
            this.$http
                .get('/ops/recruit/reg/stat', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        }
    }
}
</script>
